import { connect, useSelector } from 'react-redux';
import { appActions } from '../../reducers/app.reducer';
import { authActions } from '../../reducers/auth.reducer';
import { modalActions } from '../../reducers/modal.reducer';
import Help from './Help.modal';
var Header = function Header(_ref) {
  var _cmsUser$email, _cmsUser$email$find;
  var toggleHamburgerMenuAction = _ref.toggleHamburgerMenuAction,
    logoutAction = _ref.logoutAction,
    showModalAction = _ref.showModalAction;
  var navigate = useNavigate();
  var cmsUser = useSelector(function (s) {
    return s.auth.user || {};
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("header", {
    id: "header",
    className: "header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header__user"
  }, /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, "Welcome ", cmsUser === null || cmsUser === void 0 ? void 0 : (_cmsUser$email = cmsUser.email) === null || _cmsUser$email === void 0 ? void 0 : (_cmsUser$email$find = _cmsUser$email.find(function (x) {
    return x.primary;
  })) === null || _cmsUser$email$find === void 0 ? void 0 : _cmsUser$email$find.address), /*#__PURE__*/React.createElement("li", {
    onClick: function onClick() {
      logoutAction();
    }
  }, "logout"))), /*#__PURE__*/React.createElement("div", {
    className: "header__actions"
  }, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/icons/settings@3x.png",
    onClick: function onClick() {
      navigate("/user/".concat(cmsUser.id));
    }
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/icons/help@3x.png",
    onClick: function onClick() {
      showModalAction({
        component: /*#__PURE__*/React.createElement(Help, null)
      });
    }
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/icons/hamburger.png",
    className: "header__actions--hamburger",
    onClick: function onClick() {
      toggleHamburgerMenuAction();
    }
  }))));
};
var mdtp = {
  toggleHamburgerMenuAction: appActions.toggleHamburgerMenu,
  logoutAction: authActions.logout,
  showModalAction: modalActions.show
};
export default connect(null, mdtp)(Header);